<div class="h-full w-full relative">
    @if(config) {
    <div class="h-full w-full" [class.hidden]="isResizing">
        <app-only-office-doc-editor class="h-full w-full" [contractId]="documentId" [configData]="config"
            [editorId]="'preview_' + uniqueKey">
        </app-only-office-doc-editor>
    </div>
    @if(isResizing) {
    <div class="absolute inset-0 flex items-center justify-center bg-white">
        <div class="text-sm text-gray-600">Resizing…</div>
    </div>
    }
    }
</div>